import type { ActionNode } from "@repo/shared/workflow";
import { ExportEditor } from "./Export";
// import RESTEditor from "./REST";
import RPAEditor from "./RPA";
import { SendEmailEditor } from "./SendEmail";

const ActionEditor: React.FC<{
  workflowId: string;
  action: ActionNode;
}> = ({ workflowId, action }) => {
  return (
    <>
      {/* {action.subType === "rest" && (
        <RESTEditor workflowId={workflowId} actionId={action.id} />
      )} */}
      {action.subType === "rpa" && (
        <RPAEditor workflowId={workflowId} actionId={action.id} />
      )}
      {action.subType === "export" && (
        <ExportEditor workflowId={workflowId} actionId={action.id} />
      )}
      {action.subType === "send-email" && (
        <SendEmailEditor workflowId={workflowId} actionId={action.id} />
      )}
    </>
  );
};

export default ActionEditor;
